<template>
  <div id="afdc-embed-form" class="afdc-modal-box" v-show="$store.getters.getEmbedModalOpen" v-on-clickaway="closeEmbedForm">
    <div class="afdc-modal-closer" v-on:click="closeEmbedForm"><span class="afdc-sr-only">{{ $t('Close') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon"/></div>

    <h4>{{ $t('Embed the Alternative Fueling Station Locator') }}</h4>

    <p>{{ $t('Embed the station locator using the results you are currently viewing as the default.') }}</p>

    <form>
      <strong><label for="afdc-embed-html">{{ $t('HTML') }}</label></strong>
      <textarea type="text" class="afdc-form-control" id="afdc-embed-html" v-model="embedCode"></textarea>

      <p>{{ $t('Copy and paste this HTML into your website.') }}</p>
  </form>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [
    clickaway,
  ],

  computed: {
    embedCode() {
      const options = {
        country: window.afdcStationsOptions.country,
        localeCountry: window.afdcStationsOptions.localeCountry,
        path: this.$route.path,
        query: {
          ...this.$route.query,
          show_embed: undefined,
        },
      };

      // eslint-disable-next-line no-useless-escape
      return `<div id="afdc-stations"><div id="afdc-stations-loading">Loading alternative fueling station locator...</div></div><script type="text/javascript">window.afdcStationsOptions = ${JSON.stringify(options)}<\/script><script async defer src="${process.env.BASE_URL}assets/embed.js"><\/script><noscript>Please enable JavaScript to view the alternative fueling station locator.</noscript>`;
    },
  },

  methods: {
    closeEmbedForm() {
      if (this.$store.getters.getEmbedModalLinkClicked) {
        this.$store.commit('setEmbedModalLinkClicked', false);
      } else {
        if (this.$route.query.show_embed) {
          this.$router.push({ query: { ...this.$route.query, show_embed: undefined } });
        }
        this.$store.commit('setEmbedModalOpen', false);
      }
    },
  },
};
</script>

<style lang="scss">
#embed-form {
  width: 50%;
  max-width: 700px;

  #embed-html {
    height: 225px;
  }

  .modal-closer {
    margin-left: calc(50% - 55px);
  }

  @media (min-width: 1400px) {
    .modal-closer {
      margin-left: calc(700px - 55px);
    }
  }
}
</style>
